var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"intro-text"},[_c('ul',_vm._l((_vm.data),function(item){return _c('li',{key:item.title},[_c('h4',[_vm._v(_vm._s(item.title))]),_vm._l((item.text),function(textItem,index){return _c('p',{key:index},[_vm._v(_vm._s(textItem))])})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }